import { Component, OnInit } from '@angular/core';
import { NgxSmartModalService } from 'ngx-smart-modal';

@Component({
  selector: 'app-user-time',
  templateUrl: './user-time.component.html',
  styleUrls: ['./user-time.component.css']
})
export class UserTimeComponent implements OnInit {

  constructor(public ngxSmartModalService: NgxSmartModalService) { }

  ngOnInit() {
  }

}
